export enum ProcessType {
	RECALCULATE_RESTRICTED_PLAN = 'RECALCULATE_RESTRICTED_PLAN',
	CALCULATE_RESTRICTED_PLAN = 'CALCULATE_RESTRICTED_PLAN',
}
